import { render, staticRenderFns } from "./DeleteWatch.vue?vue&type=template&id=48153e14&scoped=true&"
import script from "./DeleteWatch.vue?vue&type=script&lang=js&"
export * from "./DeleteWatch.vue?vue&type=script&lang=js&"
import style0 from "./DeleteWatch.vue?vue&type=style&index=0&id=48153e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48153e14",
  null
  
)

component.options.__file = "DeleteWatch.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
